import { defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { createAssetValidator } from "./TLBaseAsset";
/** @internal */ export const bookmarkAssetValidator = createAssetValidator("bookmark", T.object({
    title: T.string,
    description: T.string,
    image: T.string,
    src: T.string.nullable()
}));
/** @internal */ export const bookmarkAssetMigrations = defineMigrations({});
